import React, { useMemo, useEffect } from "react"
import { BinaryChoice, BinaryChoiceProps } from "dash-styled"
import { useAsyncCommand } from "../../../Hooks/useAsyncCommand"

interface AsyncBinaryChoiceProps extends Omit<BinaryChoiceProps, "onClick"> {
    onChange?: (value: boolean) => Promise<void>
}

/**
 * Binary choice input for remote data.
 *
 * When it's clicked, it responds immediately to show changed value
 * and reverts if saving the result fails.
 */
export function AsyncBinaryChoice({
    onChange,
    isChecked,
    ...props
}: AsyncBinaryChoiceProps) {
    const handleChange = useMemo(
        () => (onChange === undefined ? undefined : () => onChange(!isChecked)),
        [onChange, isChecked]
    )
    const { isProcessing, reset, perform } = useAsyncCommand(handleChange)

    useEffect(() => {
        reset()
    }, [reset, isChecked])

    return (
        <BinaryChoice
            {...props}
            isChecked={isProcessing ? !isChecked : isChecked}
            onClick={perform}
        />
    )
}
